import classNames from "classnames";
import { MisalignmentItem, Overbooking } from "PFApp/booking/types";
import { RowType } from "PFApp/booking/types/row";
import colors from "PFTheme/tokens/colors";
import { Id } from "PFTypes";
import { useTranslation } from "react-i18next";

import { useDetailsPanelContext } from "../details_panel";
import MisalignmentErrorDetails from "./misalignment_error_details";
import { useOverbookingColor } from "./use_overbooking_color";
import css from "./warning_icons.module.scss";
import WarningTooltipIcon from "./warning_tooltip_icon";

interface WarningIconsProps {
  overbookings?: Pick<Overbooking, "date" | "utilization">[];
  misalignments?: MisalignmentItem[];
  type?: string;
  iconNotHighlighted?: boolean;
  scrollToDate?: () => void;
  roleName?: string;
  profileId: Id | undefined;
  classes?: { icon?: string };
  isOverbookingsPanelStacked: boolean;
}

const WarningIcons = ({
  overbookings,
  misalignments,
  type,
  iconNotHighlighted,
  scrollToDate,
  roleName,
  profileId,
  isOverbookingsPanelStacked
}: WarningIconsProps) => {
  const { t } = useTranslation("bookingModule");
  const overbookedCounter = overbookings?.length || 0;
  const misalignmentsCounter = misalignments?.length || 0;

  const { overbookingColor } = useOverbookingColor({ overbookings: overbookings || [] });
  const { openDetailsPanel } = useDetailsPanelContext();

  return (
    <div className={css.iconsWrapper}>
      {!!overbookedCounter && (
        <WarningTooltipIcon
          icon="warning"
          label={t("workforce.overbookedWarning")}
          iconColor={overbookingColor?.hex()}
          counterColor={overbookingColor?.hex()}
          counter={overbookedCounter}
          classes={{
            counter: classNames(css.overbookedCounter, {
              [css.lightText]: !!overbookingColor?.isDark()
            })
          }}
          onClick={
            profileId
              ? () =>
                  openDetailsPanel(
                    {
                      type: "overbookings",
                      id: Number(profileId)
                    },
                    isOverbookingsPanelStacked
                  )
              : undefined
          }
        />
      )}
      {!!misalignmentsCounter && (
        <WarningTooltipIcon
          icon="calendar-delete"
          label={t("projects.misalignment")}
          counter={misalignmentsCounter}
          iconColor={iconNotHighlighted ? colors.paletteBlue2 : colors.paletteOrange0}
          classes={{
            counter: css.misalignmentCounter
          }}
          renderExpanded={
            type === RowType.Profile && !!misalignments
              ? () => (
                  <MisalignmentErrorDetails
                    roleName={roleName}
                    misalignments={misalignments}
                    onLinkClick={scrollToDate}
                  />
                )
              : undefined
          }
        />
      )}
    </div>
  );
};

export default WarningIcons;
